import React from 'react'

import stars from './artwork.svg'
import path1 from './part1.svg'
import path2 from './path2.svg'

const Backgrounds = () => (
  <div className="backgrounds">
    <img src={stars} alt="" />
    <img src={path2} alt="" />
    <img src={stars} alt="" />
  </div>
)

export default Backgrounds



// WEBPACK FOOTER //
// ./src/components/Backgrounds/index.js